import { render, staticRenderFns } from "./BikeArchiveContainer.vue?vue&type=template&id=c874459e&"
import script from "./BikeArchiveContainer.vue?vue&type=script&lang=js&"
export * from "./BikeArchiveContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports